import reward from '@/store/modules/reward';
import eventFilters from '@/modules/Events/store/filters.js';
import eventConstructor from '@/modules/Events/store/constructor.js';
import redesignHeaderLinks from '@/store/modules/redesignHeaderLinks';
import association from '@/store/modules/association';

// MODULES
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import initModules from './init-modules';

import { rServices } from '@/plugins/api';
import { isVcht } from '@/constants/global';

Vue.use(Vuex);

const DEFAULT_TITLE = isVcht ? 'Олимпиада' : 'УМКА';

const DEFAULT_SETTINGS = {
  display_name: DEFAULT_TITLE,
  logo: null,
};

const SETTINGS_TOKEN = 'saved-settings';

const ADMIN_ACCESS_TOKEN = 'admin-access-state';

export default new Vuex.Store({
  state: {
    searchDrawer: false,
    settings: {
      ...DEFAULT_SETTINGS,
    },

    subdrawer: null,

    adminAccess: localStorage.getItem(ADMIN_ACCESS_TOKEN) === 'true' || false,
  },
  getters: {
    searchDrawer: (state) => state.searchDrawer,
    settings: (state) => state.settings,
    subdrawer: (state) => state.subdrawer,
    isAdminAccess: (state) => state.adminAccess,
  },

  actions: {
    async fetchRegionSettings({ commit }) {
      const settings = localStorage.getItem(SETTINGS_TOKEN);
      if (settings) {
        commit('SET_SETTINGS', JSON.parse(settings));
        return;
      }

      const { response, error } = await rServices.regions.getRegionSettings();
      if (error) {
        return;
      }

      const { data } = response.data;
      commit('SET_SETTINGS', data);
      localStorage.setItem(SETTINGS_TOKEN, JSON.stringify(data));
    },

    setSearchDrawer({ commit }, data) {
      commit('SET_SEARCH_DRAWER', data);
    },

    setSubdrawerType({ commit }, type) {
      commit('SET_SUBDRAWER_TYPE', type);
    },

    switchAdminAccess({ commit, getters }) {
      const newState = !getters.isAdminAccess;
      commit('SET_ADMIN_ACCESS', newState);
      localStorage.setItem(ADMIN_ACCESS_TOKEN, newState);
      Vue.$toast.success(`Вы ${newState ? '' : 'не '}в опасном режиме`);
    },
  },

  mutations: {
    SET_SEARCH_DRAWER(state, payload) {
      if (payload) {
        state.searchDrawer = payload;
      } else {
        state.searchDrawer = !state.searchDrawer;
      }
    },
    SET_SUBDRAWER_TYPE(state, payload) {
      state.subdrawer = payload;
    },
    SET_SETTINGS(state, data) {
      state.settings = data;
    },
    SET_ADMIN_ACCESS(state, data) {
      state.adminAccess = data;
    },
    CLEAR_SETTINGS(state) {
      state.settings = { ...DEFAULT_SETTINGS };
      localStorage.removeItem(SETTINGS_TOKEN);
    },
  },
  plugins: [
    createPersistedState({
      key: 'vuexdata',
      paths: ['auth'],
    }),
  ],
  modules: {
    ...initModules(),

    // MODULES
    reward,
    eventFilters,
    eventConstructor,
    redesignHeaderLinks,
    association,
  },
});
